import { render, staticRenderFns } from "./person_log.vue?vue&type=template&id=2d83d048&scoped=true"
import script from "./person_log.vue?vue&type=script&lang=js"
export * from "./person_log.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d83d048",
  null
  
)

export default component.exports